<template>
  <div class="home">
    <button
      class="button field is-info is-light"
      @click="isCardModalActive = true"
    >
      <b-icon icon="plus"></b-icon>
      <span>Novo problema identificado</span>
    </button>
    <b-table
      :data="allIdentifiedProblems"
      ref="table"
      paginated
      per-page="10"
      :striped="true"
      :debounce-search="1000"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
    >
      <b-table-column
        field="id"
        label="ID"
        :searchable="true"
        sortable
        v-slot="props"
      >
        {{ props.row.id }}
      </b-table-column>

      <b-table-column
        field="name"
        label="Nome"
        :searchable="true"
        sortable
        v-slot="props"
        >{{ props.row.name.toUpperCase() }}</b-table-column
      >

      <b-table-column v-slot="props" label="Opções">
        <button
          class="button is-small is-light"
          @click.prevent="
            onEdit(props.row)
            isCardModalActive = true
          "
        >
          <b-icon icon="pen" size="is-small"></b-icon>
        </button>
        <button
          class="button is-small is-danger"
          @click.prevent="onDelete(props.row.id)"
        >
          <b-icon icon="delete" size="is-small"></b-icon>
        </button>
      </b-table-column>

      <template slot="detail" slot-scope="props">
        <article class="media">
          <div class="media-content">
            <div class="content">
              <p>
                <strong>Nome:</strong>
                <small>{{ props.row.name }}</small>
              </p>
            </div>
          </div>
        </article>
      </template>
    </b-table>

    <b-modal v-model="isCardModalActive" :width="640" scroll="keep">
      <div class="card">
        <div class="card-content">
          <div class="content">
            <b-field label="Nome *">
              <b-input v-model="model.name" required></b-input>
            </b-field>
            <b-button type="button field is-info" class="mt-10" @click="save"
              >Salvar</b-button
            >
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import service from '../features/identified-problems/store/service'
import IdentifiedProblem from '../models/identified-problem'

export default {
  name: 'IdentifiedProblems',
  data() {
    return {
      model: IdentifiedProblem.model,
      isModalVisible: false,
      showDetailIcon: false,
      isCardModalActive: false,
    }
  },
  created() {
    this.init()
  },
  computed: {
    ...mapState('identifiedProblems', ['allIdentifiedProblems']),
  },
  methods: {
    ...mapActions('identifiedProblems', ['getAllIdentifiedProblems']),
    async init() {
      await this.getAllIdentifiedProblems()
    },
    async save() {
      const identifiedProblem = { ...this.model }

      try {
        const save = identifiedProblem.id
          ? await service.updateIdentifiedProblem(identifiedProblem)
          : await service.saveIdentifiedProblem(identifiedProblem)

        await this.$success('Problema identificado')
        await location.reload(true)
      } catch (error) {
        console.log('error', error)
        this.$error(
          error.response.data.message || error.response.data[0].message
        )
      }
    },
    async onDelete(id) {
      try {
        const result = await this.$ask(
          'Você deseja remover o problema identificado?'
        )

        if (result.isConfirmed) {
          await service.deleteIdentifiedProblem(id)

          await this.$delete('Problema identificado')
          location.reload(true)
        }
      } catch (error) {
        this.$error(error.response.data.message)
      }
    },
    onEdit(item) {
      this.model = { ...item }
    },
  },
}
</script>

<style scoped></style>